// extracted by mini-css-extract-plugin
export default {"container":"PriceRange_container__uTX03","minPrice":"PriceRange_minPrice__k7DNq","maxPrice":"PriceRange_maxPrice__NHHtM"};